export default __webpack_public_path__ + "static/media/Image1.e5b2082a.png";